export default "assets/images/texture_liste_vins-32380548.jpg";